export type CurrencyCode = "USD" | "GBP" | "EUR";

// ISO-3166-1 codes of Eurozone members
const EURO_COUNTRIES = new Set<string>([
    "AT","BE","CY","EE","FI","FR","DE","GR","IE","IT",
    "LV","LT","LU","MT","NL","PT","SK","SI","ES","HR",
]);

export function deriveCurrencyFromCountry(country: string | null | undefined): CurrencyCode {
    if (!country) return "USD";
    const code = country.toUpperCase();
    if (code === "US") return "USD";
    if (code === "GB" || code === "UK") return "GBP";
    if (EURO_COUNTRIES.has(code)) return "EUR";
    return "USD";
}

export function getCurrencySymbol(currency: CurrencyCode | string): string {
    const code = String(currency ?? "").toUpperCase();
    switch (code) {
        case "GBP":
            return "£";
        case "EUR":
            return "€";
        case "USD":
        default:
            return "$";
    }
}


